import {
  gql 
} from "@apollo/client";

export const ADD_JS_LOG = gql`
  mutation AddJsLog($input: JsLogInput) {
    addJsLog(input: $input) {
      code
      message
      content
    }
  }
`;
